<template>
    <div class="category-list-page">
        <GeekQooSearch></GeekQooSearch>
        <div class="list-container">
            <div class="list-left">
                <a
                    v-for="(item, index) in categoryList"
                    :key="index"
                    :class="categoryActive == index ? 'active' : ''"
                    @click="changeCategory(index)"
                >
                    <img :src="item.icon ? item.icon : app.emptyImg" draggable="false" />
                    <span>{{ item.title }}</span>
                </a>
            </div>
            <div class="list-right">
                <!-- 二级分类列表 -->
                <div v-if="currentLevel === 2 && categoryList[categoryActive]" class="list-wrapper">
                    <a
                        v-for="(item, index) in categoryList[categoryActive].list"
                        :key="index"
                        class="list-item"
                        @click="handleSecondLevelClick(item)"
                    >
                        <img
                            :src="item.icon ? item.icon : app.emptyImg"
                            draggable="false"
                            style="object-fit:contain "
                        />
                        <span>{{ item.title }}</span>
                    </a>
                </div>
                
                <!-- 三级分类列表 -->
                <div v-if="currentLevel === 3 && thirdLevelCategory" class="list-wrapper">
                    <div class="back-button" @click="goBackToSecondLevel">
                        <span>返回上一层分类</span>
                    </div>
                    <a
                        v-for="(item, index) in thirdLevelCategory.list"
                        :key="index"
                        class="list-item"
                        @click="toGoodsList(item)"
                    >
                        <img
                            :src="item.icon ? item.icon : app.emptyImg"
                            draggable="false"
                            style="object-fit:contain "
                        />
                        <span>{{ item.title }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 引入mixins
import mixins_config from "@/mixins/config.js";
// 引入组件
import GeekQooSearch from "@/components/GeekQooSearch";
// 引入接口
import { GOODS_GROUP } from "@/api/dataProvider";
import wx from "weixin-js-sdk";

export default {
    name: "CategoryList",
    mixins: [mixins_config],
    components: {
        GeekQooSearch
    },
    data() {
        return {
            categoryList: [],
            categoryActive: 0,
            currentLevel: 2, // 2表示二级，3表示三级
            secondLevelCategory: null, // 存储当前选中的二级分类
            thirdLevelCategory: null // 存储当前选中的三级分类
        };
    },
    watch: {
        // 监听类目数据和选中类目的变化
        categoryActive: {
            handler(newIndex) {
                if(this.categoryList && this.categoryList.length > 0) {
                    const currentCategory = this.categoryList[newIndex];
                    if(currentCategory && wx && wx.miniProgram) {
                        wx.miniProgram.postMessage({
                            data: {
                                type: 'shareInfo',
                                title: currentCategory.title || '商品分类',
                                desc: '查看全部商品分类',
                                imageUrl: currentCategory.icon || '',
                                path: `/pages/index/index?url=${encodeURIComponent(`${window.location.origin}/#/category-list?active=${newIndex}`)}`
                            }
                        });
                    }
                }
            },
            immediate: true
        }
    },
    created() {
        this.app.tabActive = 1;
    },
    mounted() {
        this.getGoodsGroup();
        if (this.$route.query.active) {
            this.categoryActive = this.$route.query.active;
        }
    },
    methods: {
        // 获取商品分类
        getGoodsGroup() {
            let that = this;
            GOODS_GROUP({}, function(res) {
                if (res.data.code === 0) {
                    console.log(res.data.data);
                    that.categoryList = res.data.data.group;
                }
            });
        },
        // 切换分类
        changeCategory(index) {
            this.categoryActive = index;
            this.currentLevel = 2; // 重置为二级分类
            this.secondLevelCategory = null;
            this.thirdLevelCategory = null;
            if (this.$route.query.active) {
                this.$router.replace({ name: this.$route.name });
            }
        },
        // 处理二级分类点击
        handleSecondLevelClick(item) {
            if (item.list && item.list.length > 0) {
                // 如果有三级分类，显示三级分类
                this.currentLevel = 3;
                this.secondLevelCategory = item;
                this.thirdLevelCategory = item;
            } else {
                // 如果没有三级分类，直接跳转到商品列表
                this.toGoodsList(item);
            }
        },
        // 返回二级分类
        goBackToSecondLevel() {
            this.currentLevel = 2;
            this.thirdLevelCategory = null;
        },
        // 跳转商品列表
        toGoodsList(item) {
            console.log(item);
            let categoryId;
            if (this.currentLevel === 3 && this.secondLevelCategory) {
                // 三级分类跳转到商品列表
                categoryId = `${this.categoryList[this.categoryActive].id}-${this.secondLevelCategory.id}-${item.id}`;
            } else {
                // 二级分类跳转到商品列表
                categoryId = `${this.categoryList[this.categoryActive].id}-${item.id}`;
            }
            this.$router.push({
                name: "GoodsList",
                query: {
                    tags: categoryId
                }
            });
        }
    }
};
</script>

<style lang="scss">
.category-list-page {
    height: 100%;

    .list-container {
        display: flex;
        width: 100%;
        height: calc(100vh - 95px);

        .list-left {
            width: 104px;
            height: 100%;
            background: #eeeeee;

            a {
                display: block;
                padding: 14px 0 14px 14px;
                border-left: 3px solid transparent;

                img {
                    vertical-align: middle;
                    width: 21px;
                    height: 21px;
                    border-radius: 50%;
                }

                span {
                    vertical-align: middle;
                    margin-left: 7px;
                    font-size: 10px;
                    color: #2d2d2d;
                }
            }

            .active {
                background: #fff;
                color: #6b4d9a;
                border-left: 3px solid #6b4d9a;
            }
        }

        .list-right {
                width: calc(100vw - 104px);
                overflow-y: scroll;

                .list-wrapper {
                    padding: 8px;

                    .back-button {
                        padding: 10px 0;
                        margin-bottom: 10px;
                        text-align: center;
                        color: #6b4d9a;
                        font-size: 12px;
                        cursor: pointer;
                        border-bottom: 1px solid #eee;
                        
                        &:hover {
                            color: #4a3669;
                        }
                    }

                    .list-item {
                        display: inline-block;
                        width: 69px;
                        margin: 6px;

                        img {
                            display: block;
                            width: 69px;
                            height: 69px;
                            object-fit: cover;
                        }

                        span {
                            display: block;
                            width: 100%;
                            margin-top: 14px;
                            text-align: center;
                            font-size: 10px;
                            color: #2d2d2d;
                        }
                    }
                }
            }
    }
}
</style>
